import { useGetDataCMS } from "data-access/graphql/hooks/useGetDataCMS";
import { getBannersQuery } from "data-access/graphql/queries/banners/getBanners.query";
import { BannersResponse } from "ui/common/components/feedback/AdsCarousel/types/adBanners.types";
import { mapBannersResponseToItems } from "ui/common/mappers/banners.mapper";

export const useGetPartnersBanners = () => {
    const { data, isLoading, error } = useGetDataCMS<BannersResponse>({
        queryKey: ["PartnersBannersCMS"],
        query: getBannersQuery({ bannerTag: "redemptionBanner" }),
    });

    return {
        banners: mapBannersResponseToItems(data),
        isLoading,
        error,
    };
};
